import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IDKeys from '../constants/idKeys';
import appConfig from '../config/appConfig';

const { commitHash, milestone, version } = appConfig;

/**
 * Renders a modal showing information about the application.
 * @param {object} props Props accepted by the component.
 * @param {boolean} props.open Indicates if the modal is showing.
 * @param {Function} props.onClose Function to close the modal.
 * @returns {React.FunctionComponent} React element that contains the modal.
 */
function AboutModal({ open, onClose }) {
  const [translate] = useTranslation('translation', {
    keyPrefix: 'about',
  });
  const milestoneString = milestone ? `-${milestone}` : '';

  return (
    <Dialog
      id={`${IDKeys.ABOUT}Dialog`}
      open={open}
      maxWidth="md"
      fullWidth
      onClose={onClose}
    >
      <DialogTitle sx={{ paddingX: 4, paddingY: 3 }}>
        <Stack direction="row" alignItems="center" gap={2}>
          <IconButton
            id={`${IDKeys.ABOUT}InfoIconButton`}
            tabIndex={-1}
            disableRipple
            disableFocusRipple
          >
            <InfoOutlinedIcon />
          </IconButton>
          <Typography id={`${IDKeys.ABOUT}TitleText`}>
            {translate('title')}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent
        id={`${IDKeys.ABOUT}Content`}
        sx={{ marginX: 4, marginY: 4, padding: 0 }}
      >
        <Typography variant="body_sm">
          {translate('version', {
            version,
            milestone: milestoneString,
            commitHash,
          })}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}

export default AboutModal;
